import { FunctionComponent, ReactElement, useState } from "react";

import { ContentWrapper, DropdownWrapper, Header, ArrowContainer, HeaderContentContainer } from "./styles";

import Arrow from "components/Arrow";

interface IProps {
  header: ReactElement;
  headerBackgroundColor?: string;
  content?: ReactElement;
  openByDefault?: boolean;
  hideArrow?: boolean;
  arrowColor?: string;
  className?: string;
  dropShadow?: boolean;
  panelTitle?: string;
}

const Dropdown: FunctionComponent<IProps> = ({
  content,
  header,
  openByDefault = false,
  hideArrow = false,
  arrowColor = "black",
  className,
  dropShadow,
  headerBackgroundColor,
  panelTitle,
}) => {
  const [shouldShowContent, setShouldShowContent] = useState<boolean>(openByDefault);

  return (
    <DropdownWrapper dropShadow={dropShadow} className={className}>
      <Header
        data-testid="dropdown"
        headerBackgroundColor={headerBackgroundColor}
        $isContentVisible={shouldShowContent}
        onClick={() => setShouldShowContent(!shouldShowContent)}
      >
        <HeaderContentContainer>{header}</HeaderContentContainer>
        {!hideArrow && (
          <ArrowContainer>
            <Arrow
              color={arrowColor}
              direction={shouldShowContent ? "up" : "down"}
              arial-label={header}
              panelTitle={panelTitle}
            />
          </ArrowContainer>
        )}
      </Header>
      {shouldShowContent && content ? <ContentWrapper data-testid="dropdown-content">{content}</ContentWrapper> : <></>}
    </DropdownWrapper>
  );
};

export default Dropdown;
